import React from "react";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OurFacilities from "./pages/OurFacilities";
import FeeStructure from "./pages/FeeStructure";
import Gallery from "./pages/Gallery";
import TermsAndConditions from "./pages/TermsAndConditions";
import Policy from "./pages/Policy";
import ScrollToTop from "./core/ScrollToTop";
import PageNotFound from "./pages/PageNotFound";
import {PageTransition} from '@steveeeie/react-page-transition';
import Navbar from "./core/Navbar";

const Routes = () => {
    return (
        <Router>
            <Navbar/>
            <Route
                render={({location}) => {
                    return (
                        <PageTransition
                            preset="roomToBottom"
                            transitionKey={location.pathname}
                        >
                            <ScrollToTop>
                                <Switch>
                                    <Route path="/" exact component={Home}/>
                                    <Route path="/about-us" exact component={About}/>
                                    <Route path="/contact-us" exact component={Contact}/>
                                    <Route path="/our-facilities" exact component={OurFacilities}/>
                                    <Route path="/fees-structure" exact component={FeeStructure}/>
                                    <Route path="/gallery" exact component={Gallery}/>
                                    <Route path="/terms-and-conditions" exact component={TermsAndConditions}/>
                                    <Route path="/Policy" exact component={Policy}/>
                                    <Route component={PageNotFound}/>
                                </Switch>
                            </ScrollToTop>
                        </PageTransition>
                    );
                }}
            />
        </Router>
    );
};

export default Routes;
